import { cn } from "@/lib/cn";
import type { ZaloAccount } from "@/lib/accounts";

/** Thanh chọn tài khoản dùng chung cho trang Nhóm và Chiến dịch. */
export function AccountSelector({
    accounts,
    value,
    onChange,
}: {
    accounts: ZaloAccount[];
    value: string | undefined;
    onChange: (accountId: string) => void;
}) {
    if (accounts.length <= 1) return null;

    return (
        <div className="flex flex-wrap gap-2">
            {accounts.map((account) => (
                <button
                    key={account.id}
                    type="button"
                    onClick={() => onChange(account.id)}
                    className={cn(
                        "flex items-center gap-2 rounded-lg border px-3 py-1.5 text-sm transition",
                        account.id === value
                            ? "border-brand bg-brand-soft font-medium text-brand"
                            : "border-line bg-surface text-ink-muted hover:text-ink",
                    )}
                >
                    {account.avatarUrl && <img src={account.avatarUrl} alt="" className="size-5 rounded-full" />}
                    {account.displayName}
                </button>
            ))}
        </div>
    );
}
